import { FC, InputHTMLAttributes } from 'react'

import styled from 'styled-components'

const StyledInput = styled.input`
  width: 100%;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  background: ${({ theme }) => theme.color.white};
  color: ${({ theme }) => theme.color.darkGrey};
  display: flex;
  height: 48px;
  padding: 0px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  text-align: center;
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.color.hoverWhite};
  }

  &:focus {
    outline: none;
    border: 1px solid ${({ theme }) => theme.color.brandGreen};
  }

  &:disabled {
    color: ${({ theme }) => theme.color.lightGrey};
    cursor: not-allowed;
  }

  &&:active {
    background-color: ${({ theme }) => theme.color.white};
  }
`

export interface ScheduleBudgetInputProps extends InputHTMLAttributes<HTMLInputElement> {
  value?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
}

export const ScheduleBudgetInput: FC<ScheduleBudgetInputProps> = ({
  value,
  onChange,
  onBlur,
  ...props
}) => (
  <StyledInput
    role='budget-input'
    value={value}
    onChange={onChange}
    onBlur={onBlur}
    {...props}
  />
)
